import {
    ContextualMenu,
    DirectionalHint,
    IContextualMenuItem,
} from 'office-ui-fabric-react/lib/ContextualMenu';
import { ControlIcons } from 'owa-control-icons';
import { EditorViewState } from 'owa-editor';
import fixupHotkeyCommand from 'owa-hotkeys/lib/utils/fixupHotkeyCommand';
import { useInjected } from 'owa-inject';
import { format } from 'owa-localize';
import { convertHotkeyStringToReadableText } from 'owa-readable-hotkeys/lib/utils/convertHotkeyStringToReadableText';
import * as React from 'react';
import { InsertLinkFromFilePickerContext } from '../types/InsertLinkFromFilePickerContext';
import { getAttachmentCommandItems } from '../utils/getAttachmentCommandItems';

export interface HyperLinkContextMenuProps {
    menuTargetElement: HTMLElement;
    onDismissMenu: () => void;
    filePickerContext: InsertLinkFromFilePickerContext;
    editorViewState: EditorViewState;
    targetWindow: Window;
    insertLinkTitle: string;
    insertLinkShortcut: string;
    showInsertLinkDialog: (editorViewState: EditorViewState, targetWindow: Window) => void;
}

const styles = require('./HyperlinkContextMenu.scss');
const classNames = require('classnames');

export function HyperlinkContextMenu(contextMenuProps: HyperLinkContextMenuProps) {
    const contextMenuItems: IContextualMenuItem[] = getAttachmentCommandItems(
        contextMenuProps.filePickerContext,
        contextMenuProps.editorViewState,
        contextMenuProps.targetWindow
    );
    const [convertHotkeyStringToReadableTextInjected] = useInjected(
        convertHotkeyStringToReadableText
    );
    const insertLinkTitle = format(
        contextMenuProps.insertLinkTitle,
        convertHotkeyStringToReadableTextInjected(
            // cast back to string because fixupHotkeyCommand returns the same type it was passed
            fixupHotkeyCommand(contextMenuProps.insertLinkShortcut) as string
        )
    );
    contextMenuItems.push(
        getInsertLinkMenuItem(
            contextMenuProps.editorViewState,
            contextMenuProps.targetWindow,
            insertLinkTitle,
            contextMenuProps.showInsertLinkDialog
        )
    );

    return (
        <ContextualMenu
            target={contextMenuProps.menuTargetElement}
            shouldFocusOnMount={true}
            onDismiss={contextMenuProps.onDismissMenu}
            items={contextMenuItems}
            directionalHint={DirectionalHint.topLeftEdge}
            gapSpace={2}
        />
    );
}

const getInsertLinkMenuItem = (
    editorViewState: EditorViewState,
    targetWindow: Window,
    insertLinkTitle: string,
    showInsertLinkDialog: (editorViewState: EditorViewState, targetWindow: Window) => void
): IContextualMenuItem => {
    return {
        key: 'insertLinkContextMenuItem',
        name: insertLinkTitle,
        title: insertLinkTitle,
        iconProps: {
            iconName: ControlIcons.Link,
            styles: { root: classNames(styles.iconRoot, styles.iconPadding) },
        },
        onClick: () => showInsertLinkDialog(editorViewState, targetWindow),
    };
};
